import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const i = ({ width: r = 20, height: n = 20, className: t, style: e }) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: n,
    className: t,
    style: e,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o.jsxs("g", { id: "Icons / Link", children: [
      /* @__PURE__ */ o.jsx("path", { id: "Vector", d: "M8.33325 11.6667C8.60482 11.9438 8.92896 12.164 9.28669 12.3143C9.64442 12.4647 10.0286 12.5421 10.4166 12.5421C10.8046 12.5421 11.1887 12.4647 11.5465 12.3143C11.9042 12.164 12.2284 11.9438 12.4999 11.6667L15.8333 8.33333C16.3858 7.7808 16.6962 7.0314 16.6962 6.25C16.6962 5.4686 16.3858 4.7192 15.8333 4.16667C15.2807 3.61413 14.5313 3.30372 13.7499 3.30372C12.9685 3.30372 12.2191 3.61413 11.6666 4.16667L11.2499 4.58333", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { id: "Vector_2", d: "M11.6667 8.33333C11.3951 8.05617 11.0709 7.83598 10.7132 7.68566C10.3555 7.53534 9.97135 7.45791 9.58332 7.45791C9.19529 7.45791 8.81116 7.53534 8.45343 7.68566C8.0957 7.83598 7.77155 8.05617 7.49999 8.33333L4.16666 11.6667C3.61412 12.2192 3.30371 12.9686 3.30371 13.75C3.30371 14.5314 3.61412 15.2808 4.16666 15.8333C4.71919 16.3859 5.46859 16.6963 6.24999 16.6963C7.03139 16.6963 7.78079 16.3859 8.33332 15.8333L8.74999 15.4167", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ] })
  }
);
export {
  i as LinkIcon
};
